<style lang="scss" scoped>
    @import "../../../../sass/variables";

    @media (max-width: 992px) {
        /* 移动排版 */
        .cell {
            width: 94%;
            margin: 10px 2% 20px 2%;
            height: 248px;
        }
    }

    @media (min-width: 992px) {
        /* 非移动排版 */
        .cell {
            width: 300px;
            height: 248px;
            margin: 20px 8px 0 8px;
        }
    }

    .cell {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        background: #fff;
        padding: 0 0 20px 0;

        a {
            text-decoration: none;
            color: inherit;
        }
    }

    .title {
        padding-left: 10%;
        padding-right: 10%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .meta {
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: 16px;
        padding: 0 5px 0 5px;
        width: inherit;
        text-align: left;
        font-size: 14px;
        line-height: 14px;

        .author {
            display: inline;
            float: left;
        }

        .subject {
            display: inline;
            float: right;
        }
    }

    .thumb > img {
        height: 150px;
        width: 100%;
        border-radius: 4px 4px 0 0;
        object-fit: cover;
        display: block;
    }

    .abstract {
        padding: 0 10px 0 10px;
        font-size: 16px;
        line-height: 18px;
        height: 18px * 2;
        overflow: hidden;
    }
</style>

<template>
    <li class="cell">
        <a :href="url" target="_self">
            <div class="thumb">
                <img v-lazy="cover" alt="文章缩略图">
            </div>
            <h4 class="title">{{ title }}</h4>
            <div class="meta">
                <div class="author">{{ author }}</div>
                <div class="subject">发表于频道『{{ subject }}』</div>
            </div>
        </a>
    </li>
</template>

<script>
    export default {
        props: {
            cover: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            },
            title: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            },
            author: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            },
            subject: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            },
            url: {
                type: String,
                default: "",
                required: true,
                validator: function (value) {
                    return value !== "";
                }
            }
        },
        methods: {
            enter(url) {
                alert(url);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/article/card.vue